export default "__VITE_ASSET__DKZzJchE__"